import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import backend from 'i18next-xhr-backend';

import translationEN from './locales/en.json';
import translationJA from './locales/ja.json';

const resources = {
  en: {
    translation: { ...translationEN }
  },
  ja: {
    translation: { ...translationJA }
  },
};

i18n
  .use(detector)
  .use(backend)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ja',

    nsSeparator: false,
    keySeparator: false,

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
